import { render, staticRenderFns } from "./teamPerson.vue?vue&type=template&id=560f7a4a&scoped=true&"
import script from "./teamPerson.vue?vue&type=script&lang=js&"
export * from "./teamPerson.vue?vue&type=script&lang=js&"
import style0 from "./teamPerson.vue?vue&type=style&index=0&id=560f7a4a&scoped=true&lang=css&"
import style1 from "./teamPerson.vue?vue&type=style&index=1&lang=css&"
import style2 from "./teamPerson.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f7a4a",
  null
  
)

export default component.exports